import { For, Show } from 'solid-js';
import { Store } from 'solid-js/store';
import { FilterTypeStore, SearchApiResponse, SearchModel } from '../../search';
import {
    StyledDropdownList,
    StyledDropdownListContainer,
    StyledDropdownListHeader,
    StyledDropdownListInner,
    UnstyledButton,
} from './dropdown-list.styles';

export type DropdownItem = {
    heading: string;
    model: SearchModel;
    slug?: string;
    items: SearchApiResponse[];
};

type Props = {
    isLoading: boolean;
    filters: Store<FilterTypeStore>;
    onClick: (slug: string, model: SearchModel) => void;
};

export const DropdownList = (props: Props) => {
    const getDropdownPurposes = () => {
        const purposes = props.filters.crop ? props.filters.strategies.purposes : props.filters.purposes;

        return purposes.map((purpose) => ({
            heading: purpose.name,
            model: 'purpose' as SearchModel,
            slug: purpose.slug,
            items: purpose.treatments,
        }));
    };

    const getDropdownItems = (): DropdownItem[] => {
        // Nothing selected, show the whole list
        if (!props.filters.crop && !props.filters.treatment && !props.filters.purpose) {
            return [
                ...[
                    {
                        heading: 'Grödor',
                        model: 'crop' as SearchModel,
                        items: props.filters.crops,
                    },
                    {
                        heading: 'Produkter',
                        model: 'product' as SearchModel,
                        items: props.filters.products,
                    },
                    {
                        heading: 'Hittade via aktiv substans',
                        model: 'product' as SearchModel,
                        items: props.filters.activeIngredientProducts,
                    },
                ],
                ...getDropdownPurposes(),
            ];
        }

        // Crop selected, show treatments & purposes
        if (props.filters.crop && !props.filters.treatment && !props.filters.purpose) {
            return getDropdownPurposes();
        }

        if ((props.filters.treatment || props.filters.purpose) && !props.filters.crop) {
            return [
                {
                    heading: 'Grödor',
                    model: 'crop' as SearchModel,
                    items: props.filters.strategies.crops,
                },
            ];
        }

        return [];
    };

    const filteredList = () => {
        if (props.filters.secondarySearchTerm) {
            return getDropdownItems();
        }

        return getDropdownItems().filter(({ items }) => items.length);
    };

    return (
        <StyledDropdownListContainer isLoading={props.isLoading}>
            <StyledDropdownListInner>
                <For each={filteredList()}>
                    {({ heading, items, model, ...rest }) => (
                        <>
                            <Show when={model === 'purpose'} fallback={<StyledDropdownListHeader>{heading}</StyledDropdownListHeader>}>
                                <UnstyledButton role="button" onClick={() => props.onClick(rest?.slug || '', model)}>
                                    Alla mål inom <strong>{heading}</strong>
                                </UnstyledButton>
                            </Show>
                            <StyledDropdownList>
                                <For each={items}>
                                    {({ name, slug }) => (
                                        <li>
                                            <UnstyledButton
                                                role="button"
                                                onClick={() => props.onClick(slug, model === 'purpose' ? 'treatment' : model)}
                                            >
                                                {name}
                                            </UnstyledButton>
                                        </li>
                                    )}
                                </For>
                            </StyledDropdownList>
                        </>
                    )}
                </For>
            </StyledDropdownListInner>
        </StyledDropdownListContainer>
    );
};
